import FlightRangeService from './FlightRangeService';
import CarrierService from './CarrierService';
import { partnerCarriers } from '../utils/partnerUtils';

export interface IExcelExportService {
  getFlightRangeExportData: (token: string) => Promise<any[]>;
  getPartnersExportData: (token: string) => Promise<any[]>;
}

const formatFlightRange = (start: number, end: number): string => {
    return `${start} - ${end}`;
  };

const ExcelExportService = {
  getFlightRangeExportData: async (token: string) => {
    try {
      const response = await FlightRangeService.getFlightRanges(token);
        return response.data.map(row => ({
        'MKT. CARRIER': row.marketingCarrier,
        'FLIGHT RANGE': formatFlightRange(row.start,  row.end),
        'OP. CARRIER': row.operatingCarrier,
        'FLIGHT TYPE': row.flightTypeDescription,
        'EFFECTIVE': row.effectiveDate,
        'DISCONTINUED': row.discontinueDate
        }));
    } catch (error) {
      console.error('Error fetching flight range data for export:', error);
      throw error;
    }
  },

  getPartnersExportData: async (token: string) => {
    try {
      const response = await CarrierService.getAll(token);

      // Filter out AS and QX carriers
      const partners = partnerCarriers(response.data);

      return partners.map(row => ({
        'CARRIER CODE': row.carrierCode,
        'PARTNER NAME': row.carrierName
      }));
    } catch (error) {
      // Just re-throw the error for the caller to handle
      throw error;
    }
  }
};

export default ExcelExportService;